<template>
  <div class="bp-card time-range">
    <card-title :title="title" />
    <div
      v-for="(item, idx) in ranges"
      :key="idx"
      class="sub-card"
    >
      <img class="card-img" :src="iconFor(idx)" :alt="title" />
      <div class="period">
        <div class="time-col">
          <div class="time-label"><span class="dot start"></span>开始时间</div>
          <div class="time-value">{{ item.start }}</div>
        </div>
        <span class="link-line"></span>
        <div class="time-col">
          <div class="time-label"><span class="dot end"></span>结束时间</div>
          <div class="time-value">{{ item.end }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CardTitle from './CardTitle'
import iconTuanyou from '../assets/icon-tuanyou.png'
import iconGaode from '../assets/icon-gaode.png'
import iconInsurance from '../assets/icon-insurance.png'

export default {
  name: 'BpTimeRangeCard',
  components: { CardTitle },
  props: {
    // '3km列表页置顶' | '品牌旗舰店' | '油品险'
    title: { type: String, default: '' },
    // [{ start, end }, ...]
    ranges: { type: Array, default: () => [] },
    // 油品险使用专属图标；否则子卡按顺序：第 1 个团油、第 2 个高德
    insurance: { type: Boolean, default: false }
  },
  methods: {
    iconFor (idx) {
      if (this.insurance) return iconInsurance
      return idx === 0 ? iconTuanyou : iconGaode
    }
  }
}
</script>

<style lang="less" scoped>
@import '../styles.less';
.time-range {
  .sub-card {
    position: relative;
    height: 90px;
    background: @bp-subcard-bg;
    border-radius: 16px;
    margin-top: 20px;
    display: flex;
    align-items: center;
    padding-left: 88px;
    overflow: hidden;
    .card-img {
      position: absolute;
      left: 20px;
      top: 20px;
      width: 50px;
      height: 50px;
      border-radius: 10px;
    }
    .period {
      display: flex;
      align-items: center;
      gap: 18px;
      .time-col {
        display: flex;
        flex-direction: column;
        gap: 10px;
        .time-label {
          display: flex;
          align-items: center;
          font-family: @font-cn;
          font-size: 16px;
          color: @bp-label;
          line-height: 1;
          .dot {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            margin-right: 10px;
            &.start { background: #00CFC9; }
            &.end { background: #FF5900; }
          }
        }
        .time-value {
          font-family: @font-num;
          font-size: 18px;
          color: @bp-num;
          line-height: 1;
        }
      }
      .link-line {
        width: 30px;
        height: 1px;
        background: @bp-axis;
      }
    }
  }
}
</style>
